const teamMembers = [
    {
        name: "Dr. Viswanadh Arigela",
        position: "Chief Executive Officer (CEO)",
        image: "images/team/Arigela.jpg",
        email: "viswanadh@ferritico.com",
        linkedin: "https://www.linkedin.com/in/viswanadh-gowtham-arigela/",
        delay: 0
    },
    {
        name: "Prof. Peter Hedström",
        position: "Co-Founder & Scientific Lead (Data Modelling)",
        image: "images/team/quickfix-peter.png",
        email: "peter@ferritico.com",
        linkedin: "https://www.linkedin.com/in/peter-hedström-7a68a2192/",
        delay: 100
    },
    {
        name: "Prof. Joakim Odqvist",
        position: "Co-Founder & Scientific Lead (Physics Modelling)",
        image: "images/team/Odqvist.jpg",
        email: "joakim@ferritico.com",
        linkedin: "https://www.linkedin.com/in/joakim-odqvist-37535122/",
        delay: 200
    },
    {
        name: "Dr. Daniel dos Santos Avila",
        position: "Materials Informatics Lead",
        image: "images/team/Daniel.jpg",
        email: "d.avila@ferritico.com",
        linkedin: "https://www.linkedin.com/in/danieldossantosavila/",
        delay: 300
    },
    {
        name: "Yanjie Lyu",
        position: "Machine Learning Engineer",
        image: "images/team/Yanjie.jpg",
        email: "yanjie.lyu@ferritico.com",
        linkedin: "https://www.linkedin.com/in/yanjie-lyu-a54953339/",
        delay: 400
    },
    {
        name: "Lovisa Åkesson",
        position: "Materials Informatics Engineer",
        image: "images/team/Lovisa.jpeg",
        email: "lovisa@ferritico.com",
        linkedin: "https://www.linkedin.com/in/lovisa-åkesson-a50b26200/",
        delay: 500
    }
];

export default teamMembers;